import BaseRequest from './base/BaseRequest'

export default class MarketStatistic extends BaseRequest {

    getMarketStatistic() {
        let url = '/market-statistic';
        return this.get(url)
    }
}
